import {
  PawIcon,
  MotorcycleIcon,
  CarIcon,
  BoatIcon,
  FurnitureIcon,
  HomeIcon,
  TractorIcon,
  FreightIcon,
  BoxIcon,
} from "@/components/svgs"
import type { ReactElement } from "react"

export type ShippingCategory =
  | "animals"
  | "motorcycles"
  | "vehicles"
  | "boats"
  | "household-items"
  | "apartment-home-moves"
  | "heavy-equipment"
  | "freight"
  | "others"

export const shippingOptions: Array<{
  value: ShippingCategory
  label: string
  icon: ReactElement
}> = [
  {
    value: "animals",
    label: "Pets and animals",
    icon: <PawIcon />,
  },
  {
    value: "motorcycles",
    label: "Motorcycles",
    icon: <MotorcycleIcon />,
  },
  {
    value: "vehicles",
    label: "Vehicles",
    icon: <CarIcon />,
  },
  {
    value: "boats",
    label: "Boats and water vehicles",
    icon: <BoatIcon />,
  },
  {
    value: "household-items",
    label: "Household items",
    icon: <FurnitureIcon />,
  },
  {
    value: "apartment-home-moves",
    label: "Apartment and home moves",
    icon: <HomeIcon />,
  },
  {
    value: "heavy-equipment",
    label: "Heavy equipment and industrial",
    icon: <TractorIcon />,
  },
  {
    value: "freight",
    label: "Freight",
    icon: <FreightIcon />,
  },
  {
    value: "others",
    label: "All other items",
    icon: <BoxIcon />,
  },
]

const categoryHeroCtaLabels: Record<ShippingCategory, string> = {
  animals: "FIND A LOVING PET TRANSPORTER",
  motorcycles: "FIND A MOTORCYCLE TRANSPORTER",
  vehicles: "FIND A VEHICLE TRANSPORTER",
  boats: "FIND A BOAT TRANSPORTER",
  "household-items": "FIND A MOVER",
  "apartment-home-moves": "FIND A MOVER",
  "heavy-equipment": "FIND A TRANSPORTER",
  freight: "FIND A FREIGHT TRANSPORTER",
  others: "FIND A TRANSPORTER",
}

export const shippingCategoryCtaLabels: Record<
  string,
  string
> = categoryHeroCtaLabels
